module.exports = __webpack_public_path__ + "img/coin-yellow.3628b916.svg";